module.exports = __webpack_public_path__ + "static/img/footer.a74a244.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/footer.jpg
// module id = lyuy
// module chunks = 9